<template>
  <div class="sofia-welcome container-fluid">
    <div class="row align-items-center">
      <div class="col">
        <sofia-brand-vue/>
      </div>
      <div class="col-auto">
        <a class="btn btn-secondary" :href="url_for_sofia_info()" target="_blank">
          + INFO
        </a>
      </div>
    </div>
    <hr class="mt-0">
    <div class="row ml-1">
      <div class="col">
        <span>{{t('sofia.sofia_form.instructions.begin')}}:</span>
        <ol>
          <li>
            {{t('sofia.sofia_form.instructions.step_1')}}
          </li>
          <li>
            {{t('sofia.sofia_form.instructions.step_2')}}
            <img class="sofia-selection" src="../../../assets/images/sofia/sofia-selection.png"/>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from 'common/mixins.js'

export default {
  name: 'sofia-welcome-vue',
  mixins: [mixins.translate, mixins.requests],
  components: {
    'sofia-brand-vue': () => import(/* webpackChunkName: "[request]" */ "components/sofia/Brand")
  }
}
</script>
